import { ElementType, FC, memo } from 'react';

import {
  AnimalNewIcon,
  EmotionNewIcon,
  FoodNewIcon,
  ObjectNewIcon,
  SportNewIcon,
  SymbolNewIcon,
  TravellingNewIcon,
} from '@gem/icons/emoji';
import { FAB } from '@gem/ui-kit';

import { EmojiCategoryName } from 'APP/constants/emojis';

import styles from './EmojiCategory.styles.m.css';

const iconByCategory: Record<EmojiCategoryName, ElementType<SVGAElement>> = {
  [EmojiCategoryName.Emotions]: EmotionNewIcon,
  [EmojiCategoryName.Nature]: AnimalNewIcon,
  [EmojiCategoryName.Food]: FoodNewIcon,
  [EmojiCategoryName.Travel]: TravellingNewIcon,
  [EmojiCategoryName.Activities]: SportNewIcon,
  [EmojiCategoryName.Objects]: ObjectNewIcon,
  [EmojiCategoryName.Symbols]: SymbolNewIcon,
};

interface IEmojiCategoryProps {
  category: EmojiCategoryName;
  isActive: boolean;
  onEmojiCategoryClick(category: EmojiCategoryName): void;
}

export const EmojiCategory: FC<IEmojiCategoryProps> = memo(
  ({ category, isActive, onEmojiCategoryClick }) => {
    const theme = isActive ? '16' : '15';

    const handleClick = (): void => onEmojiCategoryClick(category);

    return (
      <FAB
        className={styles.button}
        Icon={iconByCategory[category]}
        size="30"
        theme={theme}
        onClick={handleClick}
      />
    );
  }
);
